import type { IFaqCategory } from './faq-types';

export const faqBilling: IFaqCategory = {
  title: 'Billing & Subscription',
  slug: 'billing-and-subscription',
  items: [
    {
      question: 'How does the subscription work?',
      answer:
        'Choose a monthly or yearly plan to unlock all Pro features. Your subscription starts immediately after purchase and renews automatically until you cancel.',
    },
    {
      question: 'How do I cancel my subscription?',
      answer:
        'Subscriptions are managed through your device settings. On iOS, go to Settings, tap your name, then Subscriptions, select Cool Mate, and tap Cancel Subscription. On Android, open Google Play Store, tap your profile icon, then Payments & subscriptions, then Subscriptions, select Cool Mate, and tap Cancel.',
    },
    {
      question: 'Can I get a refund?',
      answer:
        'Refunds are handled by the app store where you made your purchase. On iOS, visit reportaproblem.apple.com and sign in with your Apple ID. On Android, open Google Play, go to Payments & subscriptions, find the purchase, and request a refund.',
    },
    {
      question: 'Will I lose my progress if I cancel?',
      answer:
        'No. Your learning progress and data are kept. You will simply lose access to Pro features and revert to the free plan when your current billing period ends.',
    },
    {
      question: 'What happens when my subscription renews?',
      answer:
        'Subscriptions automatically renew unless canceled at least 24 hours before the end of the current period. You can manage or cancel subscriptions in your device settings.',
    },
    {
      question: 'What is the lifetime plan?',
      answer:
        'The lifetime plan is a one-time purchase that gives you access to all Pro features permanently. No recurring charges. Pay once and enjoy Cool Mate Pro as long as the service is available.',
    },
    {
      question: 'What is the Founding Member program?',
      answer:
        'Early supporters of Cool Mate get 50% off any plan, locked in permanently. If you choose a subscription, your founding rate stays the same on every renewal. This offer is limited to the first 1,000 members.',
    },
    {
      question: 'How do I restore my purchase?',
      answer:
        'If you have previously purchased a subscription or lifetime plan, you can restore it from the billing screen in the app. Make sure you are signed in with the same App Store or Google Play account used for the original purchase.',
    },
  ],
};
